import React, { useState, useEffect } from 'react';
import useMobileBreakpoint from '@arctheme-hooks/useMobileBreakpoint';
import { Image } from '@project-stories/elements/Image/Image';

interface ScrollDownArrowProps {
  settings: {
    settings: {
      scroll_distance?: number;
      arrow_image?: any; // Shopify image object
      button_size?: 'small' | 'medium' | 'large';
      scroll_behavior?: 'smooth' | 'auto';
      show_on_mobile?: boolean;
      animation_delay?: number;
      mobile_breakpoint?: number;
    };
  };
}

export const ScrollDownArrow = ({ settings }) => {
  const {
    scroll_distance = 900,
    arrow_image,
    button_size = 'large',
    scroll_behavior = 'smooth',
    show_on_mobile = true,
    animation_delay = 1000,
    mobile_breakpoint
  } = settings.section;

  console.log('arrow_image', arrow_image);

  const isMobile = useMobileBreakpoint(mobile_breakpoint);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, animation_delay);
    
    return () => clearTimeout(timer);
  }, [animation_delay]);

  // Don't render if we shouldn't show on mobile
  if (isMobile && !show_on_mobile) {
    return null;
  }

  // Handle the scroll down action
  const handleScrollDown = () => {
    window.scrollTo({
      top: scroll_distance,
      behavior: scroll_behavior
    });
  };

  // Size classes based on button_size
  const sizeClasses = {
    small: 'w-12 h-12',
    medium: 'w-16 h-16',
    large: 'w-[75px] h-[75px]'
  };

  return (
    <div className="flex w-full justify-center">
        <button
            aria-label="Scroll down"
            onClick={handleScrollDown}
            className={`
                ${sizeClasses[button_size]}
                cursor-pointer transition-all duration-300 
                transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}
                hover:scale-110 active:scale-95
            `}
            >
            {arrow_image &&
                <Image 
                imageUrl={arrow_image}
                alt={arrow_image.alt || "Scroll down"}
                classes="w-full h-full object-contain"
                isLazy={false}
                />
            }
        </button>
    </div>
  );
};

export default ScrollDownArrow;